module.exports = __webpack_public_path__ + "static/media/invoice_contract_help_v2.200044fa.png";